import { createContext, useContext, useState, useCallback } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const SnackbarContext = createContext(null);

export const SnackbarProvider = ({ children }) => {
    const [snackbarState, setSnackbarState] = useState({
        open: false,
        message: '',
        severity: 'info',
        duration: 5000,
    });

    const showSnackbar = useCallback((message, severity = 'info', duration = 4000) => {
        setSnackbarState({ open: true, message, severity, duration });
    }, []);

    const handleClose = () => {
        setSnackbarState(prev => ({ ...prev, open: false }));
    };

    const snackbar = {
        success: (msg, duration) => showSnackbar(msg, 'success', duration),
        error: (msg, duration) => showSnackbar(msg, 'error', duration),
        warning: (msg, duration) => showSnackbar(msg, 'warning', duration),
        info: (msg, duration) => showSnackbar(msg, 'info', duration),
    };

    return (
        <SnackbarContext.Provider value={snackbar}>
        {children}
        <Snackbar
            open={snackbarState.open}
            autoHideDuration={snackbarState.duration}
            onClose={handleClose}
            anchorOrigin={{vertical: 'top', horizontal: 'center'}}
        >
            <Alert
            onClose={handleClose}
            severity={snackbarState.severity}
            variant="filled"
            sx={{ width: '100%', color: '#FFFFFF' }}
            >
            {snackbarState.message}
            </Alert>
        </Snackbar>
        </SnackbarContext.Provider>
    );
};

export const useSnackbarAlert = () => {
    const context = useContext(SnackbarContext);
    if (!context) {
        throw new Error('useSnackbarAlert must be used within SnackbarProvider');
    }
    return context;
};